import axios from "axios"
import { env } from '../constants'


/* GET */
export const get = data => {
    const token = localStorage.getItem("token")
    const uri = `${env.startpoint}/admin/dashboard/get`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}
